var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "popstyle2", staticStyle: { padding: "0 12px" } },
    [
      _c(
        "b-modal",
        {
          ref: "logsActividadManagementModal",
          staticStyle: { "margin-top": "0" },
          attrs: {
            id: "logs-management-modal",
            size: "lg",
            title: _vm.modalTitle,
            centered: "",
            "hide-footer": true,
            disabled: "true"
          },
          on: { hidden: _vm.onHidden }
        },
        [
          _c(
            "b-card",
            { staticClass: "mb-16" },
            [
              _c(
                "b-form",
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: 2 } },
                        [
                          _c(
                            "b-form",
                            [
                              _vm._v(
                                "\n              Fecha inicio\n              "
                              ),
                              _c("datepicker", {
                                staticClass: "margin-top-10",
                                attrs: {
                                  placeholder: "Seleccionar Fecha",
                                  "bootstrap-styling": true,
                                  format: _vm.customFormatter
                                },
                                model: {
                                  value: _vm.inputs.dateStart.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.inputs.dateStart, "value", $$v)
                                  },
                                  expression: "inputs.dateStart.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: 2 } },
                        [
                          _c(
                            "b-form",
                            [
                              _vm._v(
                                "\n              Fecha Fin\n              "
                              ),
                              _c("datepicker", {
                                staticClass: "margin-top-10 datep",
                                attrs: {
                                  placeholder: "Seleccionar Fecha",
                                  "bootstrap-styling": true,
                                  format: _vm.customFormatter
                                },
                                model: {
                                  value: _vm.inputs.dateEnd.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.inputs.dateEnd, "value", $$v)
                                  },
                                  expression: "inputs.dateEnd.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "right-side" },
                        [
                          _c(
                            "b-form",
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass:
                                    "btn-lg margin-top padding-btn align-button",
                                  attrs: { variant: "primary" },
                                  on: { click: _vm.submitFilters }
                                },
                                [_vm._v("Buscar\n              ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.showLogsList
            ? _c(
                "b-card",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { cols: 12 } }, [
                        _c("h5", [_vm._v("Resultados Logs")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "margin-bottom": "16px",
                                  display: "flex"
                                }
                              },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "ml-1",
                                    staticStyle: {
                                      display: "flex",
                                      "flex-direction": "row",
                                      "align-items": "center"
                                    },
                                    on: { click: _vm.exportar }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "p-0 fa fa-download",
                                      staticStyle: { "margin-right": "8px" }
                                    }),
                                    _vm._v(" Exportar a XLS\n              ")
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            !_vm.loading
                              ? _c("v-server-table", {
                                  ref: "logs-actividad-table",
                                  staticClass: "table-hide-nativetoggler",
                                  attrs: {
                                    url: "lista-logs-actividad/",
                                    columns: _vm.columns,
                                    options: _vm.options
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "fecha",
                                      fn: function(props) {
                                        return _c("div", {}, [
                                          _c("span", {}, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("formatDate")(
                                                    props.row.fecha
                                                  )
                                                )
                                            )
                                          ])
                                        ])
                                      }
                                    },
                                    {
                                      key: "usuario_ejecutor",
                                      fn: function(props) {
                                        return _c("div", {}, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                props.row.usuario_ejecutor
                                              ) + " "
                                            )
                                          ])
                                        ])
                                      }
                                    },
                                    {
                                      key: "child_row",
                                      fn: function(props) {
                                        return _vm.options.details
                                          ? undefined
                                          : undefined
                                      }
                                    }
                                  ])
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Layout/SystemManagement/logs-management/LogsActividad.vue?vue&type=template&id=0b5e1ce8&
// module id = null
// module chunks = 